import { useRef, useState } from "react";

const Playbook = () => {
  const iframeRef = useRef(null);
  const [loaded, setLoaded] = useState(false);

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "calc(100vh - 64px)" }}>
      {/* Thin loading bar */}
      {!loaded && (
        <div style={{
          height: 3,
          background: "linear-gradient(90deg, #7c3aed, #a855f7, #7c3aed)",
          backgroundSize: "200% 100%",
          animation: "shimmer 1.2s infinite linear",
        }} />
      )}

      <iframe
        ref={iframeRef}
        src="/bd-playbook.html"
        title="BD Team Playbook"
        onLoad={() => setLoaded(true)}
        style={{
          flex: 1,
          width: "100%",
          border: "none",
          display: "block",
        }}
      />

      <style>{`
        @keyframes shimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>
    </div>
  );
};

export default Playbook;
